import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/components/Login'
import DriverDashboard from '@/components/DriverDashboard'
import ResetPassword from '@/components/ResetPassword'
import SendResetLink from '@/components/SendResetLink'
import Zone from '@/components/Zone'
import EditProfile from '@/components/EditProfile'
import Vehicles from '@/components/Vehicles'
import IDBadge from '@/components/IDBadge'
import IDBadgeWeb from '@/components/IDBadgeWeb'

Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '/login',
      name: 'Login',
      component: Login,
      meta: {
        guest: true
      }
    },
    {
      path: '/send-reset-link/',
      name: 'SendResetLink',
      component: SendResetLink,
      meta: {
        guest: true
      }
    },
    {
      path: '/reset/:id_user/:code/',
      name: 'ResetPassword',
      component: ResetPassword,
      meta: {
        guest: true
      }
    },
    {
      path: '/driver-dashboard/',
      name: 'DriverDashboard',
      component: DriverDashboard
    },
    {
      path: '/zone/',
      name: 'Zone',
      component: Zone
    },
    {
      path: '/edit-profile/',
      name: 'EditProfile',
      component: EditProfile
    },
    {
      path: '/vehicles/',
      name: 'Vehicles',
      component: Vehicles
    },
    {
      path: '/',
      name: 'Root',
      redirect: '/driver-dashboard/'
    },
    {
      path: '/id-badge',
      name: 'IDBadge',
      component: IDBadge,
      meta: { standalone: true , guest: true },
    },
    {
      path: '/id-badge-web',
      name: 'IDBadgeWeb',
      component: IDBadgeWeb,
      meta: {
        guest: true
      }
    },
  ]
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js